function formatCurrency(number, currency) {
	if (number === undefined || number === null) return '';
	let options = {};
	if (currency) {
		options.style = 'currency';
		options.currency = currency;
		options.currencyDisplay = 'code';
	} else {
		options.maximumFractionDigits = 2;
		options.minimumFractionDigits = 2;
	}

	let locale  = localStorage.getItem('locale') || 'no';
	if (locale === 'no') {
		locale = 'nb';
	}
	return new Intl.NumberFormat(locale, options).format(number);
}

export default formatCurrency;